var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrentLocationPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_161_1764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2376 0.0298703L20.4539 0C34.5119 0.438097 44.0216 15.2111 38.318 28.6043C35.2 35.9283 28.8181 37.9993 24.5839 44.3631C23.8402 45.4811 22.147 48.9389 21.3324 49.5534C20.4622 50.2105 19.1972 50.1394 18.4216 49.3514C17.5583 48.4752 16.4129 45.986 15.5969 44.7883C14.5321 43.2251 13.135 41.4799 11.8214 40.1343C9.10932 37.3535 6.08726 35.7177 3.77275 32.3993C-5.50753 19.0885 3.35016 0.702663 19.2376 0.0298703ZM19.1333 11.4232C12.7611 12.0306 9.09542 19.2763 12.269 24.9844C15.6456 31.0566 24.3225 31.0637 27.7046 24.9844C31.2591 18.595 26.2714 10.7419 19.1333 11.4232Z",
    fill: "var(--button-color)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_161_1764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocationPin);
export default __webpack_public_path__ + "static/media/CurrentLocationPin.1e7bd4110464afa31a1d51c53d3526f0.svg";
export { ForwardRef as ReactComponent };